import { ukLocale } from './MappedLocales';

type FormatNumberConfig = Intl.NumberFormatOptions & {
  // This is for formatting pricing i.e. to display 0.50 instead of 0.5
  wholeOrTwoDigits?: boolean;
};

export const formatNumber = (
  value: number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
  config: FormatNumberConfig = {},
) => {
  const { wholeOrTwoDigits, ...intlConfig } = config;
  const fractionDigits = wholeOrTwoDigits ? (Number.isInteger(value) ? 0 : 2) : undefined;
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits,
    maximumFractionDigits,
    ...intlConfig,
    ...(fractionDigits === undefined
      ? {}
      : {
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        }),
  };

  return new Intl.NumberFormat(ukLocale, options).format(value);
};
